import { Box, Button, Modal, Typography } from "@mui/material";

import React from "react";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: "70%", sm: "70%", md: "50%", lg: "30%" },
  maxHeight: "60%",
  overflow: "auto",
  bgcolor: "background.paper",
  border: "1px solid #000",
  boxShadow: 24,
  p: 4,
};

export const ModalSocioSinAutenticar = ({ open }) => {
  return (
    <Modal
      open={open}
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
      onClose={() =>
        (window.location.href = process.env.REACT_APP_URL_REDIRECT_ALEPH)
      }
    >
      <Box sx={style}>
        <Typography id="modal-modal-title" variant="h6" component="h2">
          Autenticación
        </Typography>
        <Box mt={2} sx={{ justifyContent: "left", display: "flex" }}>
          <Typography variant="subtitle1">
            Debe autenticarse en el portal de Fibras para continuar.
          </Typography>
        </Box>

        <Box
          mt={2}
          mb={1}
          sx={{ justifyContent: "space-between", display: "flex" }}
        >
          <Button
            variant="contained"
            color="primary"
            onClick={() =>
              (window.location.href = process.env.REACT_APP_URL_REDIRECT_ALEPH)
            }
          >
            Autenticarse
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};
